module.exports = __webpack_public_path__ + "img/warning.5b9e6f2a.png";